import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

const isOfficerRole = (role) =>
  role === ROLES.OFFICER ||
  role === ROLES.PROCUREMENT_BUYER ||
  role === ROLES.REQUESTOR;

export const DownloadDomesticVendor = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.downloadDomesticVendorExcel}`,
    "",
    true,
    "file"
  );
};

export const DownloadInternationalVendor = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.downloadInternationalVendorExcel}`,
    "",
    true,
    "file"
  );
};

export const pendingList = (page, per_page, search, column) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${
          apiClient.Urls.officer_pending_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`
      : `${
          apiClient.Urls.admin_pending_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`,
    "",
    true
  );
};

export const approvedList = (page, per_page, search, column) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${
          apiClient.Urls.officer_approved_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`
      : `${
          apiClient.Urls.admin_approved_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`,
    "",
    true
  );
};

export const blockedList = (page, per_page, search, column) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${
          apiClient.Urls.officer_blocked_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`
      : `${
          apiClient.Urls.admin_blocked_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`,
    "",
    true
  );
};

export const returnedList = (page, per_page, search, column) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${
          apiClient.Urls.officer_returned_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`
      : `${
          apiClient.Urls.admin_returned_list
        }?page=${page}&per_page=${per_page}&search=${search || ""}&column=${
          column || ""
        }`,
    "",
    true
  );
};
export const getAllVendorForAdmin = (
  status,
  register,
  page,
  per_page,
  search,
  filter,
  column
) => {
  return apiClient.get(
    `${
      apiClient.Urls.getALLVendorAdmin
    }?status=${status}&register=${register}&page=${page}&per_page=${per_page}&filter=${filter}&column=${column}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const upload_reg = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.vendor_reg_upload}`,
    payload,
    true,
    "file"
  );
};

export const sendToSAP = (payload) => {
  return apiClient.post(`${apiClient.Urls.pushTosap}`, payload, true);
};

// jaslok
export const sendToERPJaslok = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.pushToERPForJaslok}/${payload}`,
    "",
    true
  );
};

// Universal ERP (Oracle EBS) retry / push
export const retryErpPushAPI = (payload) => {
  return apiClient.post(`${apiClient.Urls.erp_retry_push}`, payload, true);
};

export const fetchErpLogsAPI = (vendorId) => {
  return apiClient.get(
    `${apiClient.Urls.erp_logs}?vendor_id=${vendorId}`,
    "",
    true
  );
};

export const fetchExtendVendorListAPI = ({ search = "", page = 1 } = {}) => {
  return apiClient.get(
    `${apiClient.Urls.vendor_site_extend}/vendors?search=${encodeURIComponent(search)}&page=${page}&per_page=20`,
    "",
    true
  );
};

export const fetchExtendVendorOptionsAPI = (vendorId) => {
  return apiClient.get(
    `${apiClient.Urls.vendor_site_extend}/${vendorId}/options`,
    "",
    true
  );
};

export const extendVendorAPI = (payload) => {
  return apiClient.post(apiClient.Urls.vendor_site_extend, payload, true);
};

export const fetchVendorCodewithCompany = (payload) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${apiClient.Urls.fetchVendorcodeWithCompanyNameForOfficer}/${payload}`
      : `${apiClient.Urls.fetchVendorcodeWithCompanyName}/${payload}`,
    "",
    true
  );
};

export const vendorListCount = (payload) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${apiClient.Urls.officer_vendor_count}`
      : `${apiClient.Urls.admin_vendor_count}`,
    "",
    true
  );
};
export const DownloadAprovedVendor = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.downloadApprovedVendorExcel}`,
    "",
    true,
    "file"
  );
};
export const initiatedVendorDataAPI = (page, per_page, search) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  return apiClient.get(
    isOfficerRole(role)
      ? `${
          apiClient.Urls.OfficerInitiatedVendorData
        }?page=${page}&per_page=${per_page}&search=${search || ""}`
      : `${
          apiClient.Urls.initiatedVendorData
        }?page=${page}&per_page=${per_page}&search=${search || ""}`,
    "",
    true
  );
};
